import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import AbstractSlideTransform from '@app/transforms/slides/AbstractSlideTransform';
import ISkiRegionSlideData from '@app/types/data/slides/ISkiRegionSlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';

/**
 * Transform for 016-SkiRegionSlide
 */
export default class SkiRegionSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'SkiRegionSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<ISkiRegionSlideData> {
		const region: any = slide.fields.region.fields;

		const data: ISkiRegionSlideData = {
			...(await super.transform(slide, presentationSettings)),
			headline: region.title,
			pisteLength: region.pisteLength,
			lifts: region.numberOfLifts,
			sledTrackLength: region.sledTrackLength,
			winterHikeLength: region.hikeLength,
			elevationMin: region.elevationMin,
			elevationMax: region.elevationMax,
			operatingTimes: AbstractSlideTransform.parseObjectWithOperatingTimes(region)
		};

		return data;
	}
}
